import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const PrivacyPolicyPage: React.FC = () => {
  const content = `🛡️ Datenschutzerklärung für Sistasouk.de
1. Verantwortliche Stelle
Betreiberin der Plattform:
Vor- und Nachname
Sistasouk.de
E-Mail: [deine@adresse.de]
(im Folgenden: „wir“, „uns“ oder „Betreiberin“)

2. Allgemeines zur Datenverarbeitung
Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Personenbezogene Daten werden vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (DSGVO, BDSG, TKG, TDSG) sowie dieser Datenschutzerklärung behandelt.
Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Plattform, zur Kommunikation mit Nutzerinnen und zur Abwicklung der von Nutzerinnen genutzten Funktionen (z. B. Registrierung, Inserate, Nachrichten) erforderlich ist.

3. Erhebung und Speicherung personenbezogener Daten
Folgende Daten werden beim Besuch von Sistasouk.de oder bei der Registrierung verarbeitet:
Vorname, Nachname
E-Mail-Adresse
Benutzername
Passwort (verschlüsselt)
ggf. Profilbild, Standort, Inseratsinformationen
Kommunikationsinhalte (z. B. Chat, Bewertungen, Kommentare)
Zahlungsinformationen (nur indirekt über PayPal – keine Speicherung bei uns)
Logdaten (IP-Adresse, Datum, Uhrzeit, Browsertyp, Gerätedaten)

4. Zwecke der Datenverarbeitung
Die Datenverarbeitung erfolgt zur:
Bereitstellung und Verwaltung des Nutzerkontos,
Darstellung von Inseraten und Kommunikation innerhalb der Community,
technischen Wartung und Verbesserung der Plattform,
Missbrauchsverhinderung und Sicherheit,
Kontaktaufnahme bei Supportanfragen.

5. Rechtsgrundlage
Die Datenverarbeitung erfolgt auf Basis von:
Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung / Nutzung der Plattform),
Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse – Sicherheit, Funktionsfähigkeit),
ggf. Art. 6 Abs. 1 lit. a DSGVO (Einwilligung, z. B. Newsletter).

6. Weitergabe von Daten
Eine Weitergabe personenbezogener Daten erfolgt nur, wenn:
dies zur Vertragserfüllung notwendig ist (z. B. PayPal),
eine gesetzliche Verpflichtung besteht,
oder Sie ausdrücklich eingewilligt haben.
Wir geben keine Daten zu Werbezwecken an Dritte weiter.

7. Zahlungsabwicklung über PayPal
Zahlungen erfolgen ausschließlich über den externen Zahlungsdienstleister PayPal (Europe) S.à r.l. et Cie, S.C.A.
Bei Nutzung von PayPal gelten die Datenschutzbestimmungen von PayPal, abrufbar unter:
https://www.paypal.com/de/webapps/mpp/ua/privacy-full
Wir selbst speichern keine Kontodaten oder Transaktionsdetails.

8. Cookies und Tracking
Sistasouk.de verwendet technisch notwendige Cookies, um die Nutzung der Plattform zu ermöglichen (z. B. Login, Sitzungsverwaltung).
Optionale Analyse- oder Marketing-Cookies werden nur nach Einwilligung eingesetzt.

9. Speicherdauer und Löschung
Personenbezogene Daten werden gelöscht, sobald sie für die Zwecke, für die sie erhoben wurden, nicht mehr erforderlich sind oder eine Nutzerin ihr Konto löscht.
Gesetzliche Aufbewahrungsfristen bleiben unberührt.

10. Rechte der Nutzerinnen
Sie haben jederzeit das Recht auf:
Auskunft über gespeicherte Daten (Art. 15 DSGVO),
Berichtigung unrichtiger Daten (Art. 16 DSGVO),
Löschung („Recht auf Vergessenwerden“, Art. 17 DSGVO),
Einschränkung der Verarbeitung (Art. 18 DSGVO),
Datenübertragbarkeit (Art. 20 DSGVO),
Widerspruch gegen die Verarbeitung (Art. 21 DSGVO).
Beschwerden können Sie an die zuständige Datenschutzaufsichtsbehörde richten:
Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)
Kavalleriestraße 2-4, 40213 Düsseldorf
www.ldi.nrw.de

11. Sicherheit
Wir verwenden aktuelle technische und organisatorische Maßnahmen, um Ihre Daten gegen Verlust, Manipulation oder unbefugten Zugriff zu schützen.

12. Änderungen
Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen. Die jeweils aktuelle Version ist auf Sistasouk.de/datenschutz einsehbar.

🏛️ Impressum (gemäß § 5 TMG & § 14 UGB)
Betreiberin der Website:
Vorname Nachname
Sistasouk.de
[Deine Straße und Hausnummer]
[PLZ, Ort]
Deutschland
📧 E-Mail: [deine@adresse.de]
🌐Website:https://sistasouk.de
Verantwortlich für den Inhalt:
Vorname Nachname (Betreiberin der Plattform)
Umsatzsteuer-ID: (falls vorhanden, sonst „nicht umsatzsteuerpflichtig“)
Telefonnummer: (optional, aber empfohlen für behördliche Rückfragen)
Hinweis gemäß § 36 VSBG:
Die Betreiberin ist nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.

✅ Zusatzempfehlungen für Veröffentlichung:
Platziere im Footer deiner Website die Links:
„AGB“ | „Datenschutz“ | „Impressum“ | „Community-Regeln“
Verwende eine Checkbox beim Registrieren:
„Ich habe die AGB und Datenschutzerklärung gelesen und akzeptiere sie.“
Bewahre die Zustimmung (Log) aus Nachweisgründen auf.`;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography
          component="div"
          sx={{ whiteSpace: 'pre-wrap', fontSize: '1rem', lineHeight: 1.75 }}
        >
          {content}
        </Typography>
      </Container>
    </Box>
  );
};

export default PrivacyPolicyPage;
